import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstadoCuentaService extends BaseService{
    url = `${ environment.host }/estado-cuenta`;

    async getEstadoCuenta( filtros : Record< string, any > ) {
        try {
            await this.updateToken();
            let url = `${this.url}/get-estado-cuenta`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`,{ filtros }, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async getAgrupaciones(){
        try {
            await this.updateToken();
            let url = `${this.url}/get-agrupaciones`;
            const resp = await lastValueFrom( this.http.get<any>(`${url}`, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

}
